

const Benefits = ({ image, imagePosition = "left" }) => {
    const benefits = [
      "Full of Antioxidants - Rich in natural antioxidants that help fight free radicals",
      "Improves Skin Health - Promotes healthy and glowing skin complexion",
      "Inflammatory Properties - Helps reduce inflammation in the body",
      "Enhance the flavor - Adds a unique taste to your dishes while being healthy"
    ];
  
    return (
      <section className="bg-gradient-to-r from-[#A05E2A] to-[#E7C1A6] py-13 px-4">
        <div className={`max-w-6xl mx-auto flex flex-col ${imagePosition === "left" ? "md:flex-row" : "md:flex-row-reverse"} gap-8 md:gap-12`}>
          {/* Image Section */}
          {image && (
            <div className="md:w-1/2 flex items-center justify-center">
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-auto max-h-[500px] object-contain rounded-lg"
              />
            </div>
          )}
  
          {/* Content Section */}
          <div className="md:w-1/2 flex flex-col justify-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-8">
              A Pinch of Health<br />in Every Dish
            </h2>
            
            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-4">
                  <svg 
                    className="flex-shrink-0 w-6 h-6 text-[#77422B] mt-1"
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M5 13l4 4L19 7" 
                    />
                  </svg>
  
                  <p className="text-white text-lg">
                    <span className="font-semibold">
                      {benefit.split(' - ')[0]}
                    </span>
                    {benefit.split(' - ')[1] && (
                      <span className="block text-gray-700 mt-1">
                        {benefit.split(' - ')[1]}
                      </span>
                    )}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  };
  
export default Benefits;